export const getPriorityColor = (priority: string): string => {
  switch (priority) {
    case 'HIGH':
      return '#ef4444';
    case 'MEDIUM':
      return '#f59e0b';
    case 'LOW':
      return '#10b981';
    default:
      return '#6b7280';
  }
};

export const getPriorityText = (priority: string): string => {
  switch (priority) {
    case 'HIGH':
      return 'Высокий';
    case 'MEDIUM':
      return 'Средний';
    case 'LOW':
      return 'Низкий';
    default:
      return priority;
  }
};

export const getStatusColor = (status: any): string => {
  return status?.color || '#6b7280';
}; 